// extracted by mini-css-extract-plugin
export default {"tooltipText":"GridCellTooltip_tooltipText__MCh92","tooltipTarget":"GridCellTooltip_tooltipTarget__GJXG3"};